"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _field = _interopRequireDefault(require("./field"));

var MultipleValueField =
/*#__PURE__*/
function (_Field) {
  (0, _inherits2.default)(MultipleValueField, _Field);

  function MultipleValueField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MultipleValueField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MultipleValueField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'MultipleValueField');
    return _this;
  }

  (0, _createClass2.default)(MultipleValueField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(MultipleValueField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'minSize',
            component: 'IntegerField'
          }, {
            name: 'maxSize',
            component: 'IntegerField'
          }, {
            name: 'field',
            component: 'Field'
          }, {
            name: 'allowScalar',
            component: 'BooleanField'
          }]
        }
      });
    }
  }, {
    key: "_validateValueType",
    value: function _validateValueType(value) {
      var hasError = false;

      if (value === null || Array.isArray(value) || this.get('allowScalar')) {// No error
      } else {
        hasError = true;
      }

      this._hasTypeError = hasError;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this._validateValueType(value);

      (0, _get2.default)((0, _getPrototypeOf3.default)(MultipleValueField.prototype), "setValue", this).call(this, value);
    }
  }, {
    key: "validate",
    value: function validate() {
      this.clearErr();
      (0, _get2.default)((0, _getPrototypeOf3.default)(MultipleValueField.prototype), "validate", this).call(this);
      var errors = [];

      if (this._hasTypeError) {
        errors.push({
          error: 'must be an array'
        });
      } else {
        // We only want to proceed to validate the fields after we know there is no type error as type
        // errors can result in field errors and we want to report the root issue.
        var value = this.getValue(); // We use value and not isBlank() as the values can be out of sync

        if (value) {
          var minSize = this.get('minSize');
          var maxSize = this.get('maxSize');

          if (minSize !== null && value.length < minSize) {
            errors.push({
              error: "".concat(minSize, " or more")
            });
          } else if (maxSize !== null && value.length > maxSize) {
            errors.push({
              error: "".concat(maxSize, " or less")
            });
          }
        } // TODO: allowDuplicates

      }

      if (errors.length > 0) {
        this.setErr(errors);
      }
    }
  }]);
  return MultipleValueField;
}(_field.default);

exports.default = MultipleValueField;